(() => {
  const pushEvent = (eventName, parameters = {}) => {
    if (typeof window.belloTrack === "function") {
      window.belloTrack(eventName, parameters);
      return;
    }
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({ event: eventName, ...parameters });
  };

  const bindTrackedLinks = (root = document) => {
    root.querySelectorAll("[data-av3-event]").forEach((element) => {
      if (element.dataset.av3EventBound === "true") return;
      element.dataset.av3EventBound = "true";
      element.addEventListener("click", () => {
        const productNode = element.closest("[data-product-id]");
        pushEvent(element.dataset.av3Event, {
          destination: element.getAttribute("href") || "",
          product_id: productNode?.dataset.productId || "",
          product_handle: productNode?.dataset.productHandle || "",
          variant_id: productNode?.dataset.variantId || "",
        });
      });
    });
  };

  const bindRunways = (root = document) => {
    root.querySelectorAll("[data-av3-runway]").forEach((runway) => {
      if (runway.dataset.av3RunwayBound === "true") return;
      runway.dataset.av3RunwayBound = "true";

      const viewport = runway.querySelector(".av3-runway__viewport");
      const cards = [...runway.querySelectorAll("[data-av3-runway-card]")];
      const count = runway.querySelector("[data-av3-runway-count]");
      const progress = runway.querySelector("[data-av3-runway-progress]");
      const previous = runway.querySelector("[data-av3-runway-prev]");
      const next = runway.querySelector("[data-av3-runway-next]");
      const controls = runway.querySelector(".av3-runway__controls");
      if (!viewport || !cards.length) return;

      let frame = 0;
      let currentIndex = 0;
      let navigationIntent = false;
      const leadingEdge = () => viewport.getBoundingClientRect().left + parseFloat(getComputedStyle(viewport).paddingLeft || "0");
      const sync = () => {
        frame = 0;
        const viewportStart = leadingEdge();
        let closestDistance = Number.POSITIVE_INFINITY;
        let closestIndex = 0;

        cards.forEach((card, index) => {
          const distance = Math.abs(card.getBoundingClientRect().left - viewportStart);
          if (distance < closestDistance) {
            closestDistance = distance;
            closestIndex = index;
          }
        });

        const maximumScroll = viewport.scrollWidth - viewport.clientWidth;
        if (!navigationIntent) {
          currentIndex = closestIndex;
          if (maximumScroll > 1 && viewport.scrollLeft >= maximumScroll - 2) currentIndex = cards.length - 1;
        }
        if (previous) previous.disabled = currentIndex === 0;
        if (next) next.disabled = currentIndex === cards.length - 1;

        cards.forEach((card, index) => {
          card.classList.toggle("is-current", index === currentIndex);
        });

        const currentLabel = String(currentIndex + 1).padStart(2, "0");
        const totalLabel = String(cards.length).padStart(2, "0");
        if (count) count.textContent = `${currentLabel} / ${totalLabel}`;
        if (progress) {
          progress.style.setProperty("--av3-runway-progress", `${((currentIndex + 1) / cards.length) * 100}%`);
        }
      };

      const move = (direction) => {
        currentIndex = Math.max(0, Math.min(cards.length - 1, currentIndex + direction));
        navigationIntent = true;
        const maximumScroll = Math.max(0, viewport.scrollWidth - viewport.clientWidth);
        const requestedScroll = cards[currentIndex].offsetLeft - cards[0].offsetLeft;
        viewport.scrollTo({
          left: Math.max(0, Math.min(maximumScroll, requestedScroll)),
          behavior: window.matchMedia("(prefers-reduced-motion: reduce)").matches ? "auto" : "smooth",
        });
        sync();
      };
      previous?.addEventListener("click", () => move(-1));
      next?.addEventListener("click", () => move(1));
      if (controls) controls.hidden = false;

      viewport.addEventListener(
        "scroll",
        () => {
          if (frame) cancelAnimationFrame(frame);
          frame = requestAnimationFrame(sync);
        },
        { passive: true },
      );
      ["pointerdown", "touchstart", "wheel"].forEach((eventName) => {
        viewport.addEventListener(eventName, () => { navigationIntent = false; }, { passive: true });
      });
      sync();
    });
  };

  const init = (root = document) => {
    bindTrackedLinks(root);
    bindRunways(root);
  };

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", () => init());
  } else {
    init();
  }

  document.addEventListener("shopify:section:load", (event) => init(event.target));
})();
